import { PaymentMethod } from './enums';

export const addPaymentMethodIcon = (method: number | undefined) => {
  if (!method || !(method in PaymentMethod)) return null;

  const paymentMethod = PaymentMethod[method];

  return <span className="fs-9">{paymentMethod}</span>;
};
